var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel__partners"},[_c('infinite-slide-bar',{attrs:{"duration":"40s"}},[_c('div',{staticClass:"items"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('div',{staticClass:"item-img"},[_c('img',{attrs:{"src":item.media[0].original_url}})])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }